import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule, IonicPageModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { HttpModule } from '@angular/http';
import { IonicStorageModule } from '@ionic/storage';
import { NativeAudio } from '@ionic-native/native-audio';
import { OneSignal } from '@ionic-native/onesignal';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { ReservationPage } from '../pages/reservation/reservation';
import { OrderdetailsPage } from '../pages/orderdetails/orderdetails';
import { AvailabilityPage } from '../pages/availability/availability';
import { ReservationdetailsPage } from '../pages/reservationdetails/reservationdetails';
import {AddPrinterPage} from '../pages/add-printer/add-printer'
import {PrinterPage} from '../pages/printer/printer'
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DbservicesProvider,ChatService } from '../providers/dbservices/dbservices';
import { BackgroundMode } from '@ionic-native/background-mode';
import {DashboardPage} from '../pages/dashboard/dashboard'
import { BluetoothSerial } from '@ionic-native/bluetooth-serial';
import { BluetoothLE } from '@ionic-native/bluetooth-le';
import { PrintProvider } from '../providers/print/print';
import {OrdersPage,FormatTimePipe} from '../pages/orders/orders';
import {DeliveryTimePage} from '../pages/delivery-time/delivery-time';
import {MarkaspaidPage} from '../pages/markaspaid/markaspaid';

import {ReportlistPage} from '../pages/reportlist/reportlist';
import {SalesReportPage} from '../pages/sales-report/sales-report';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    OrderdetailsPage,
    ReservationPage,
    ReservationdetailsPage,
    AddPrinterPage,
    PrinterPage,
    DashboardPage,
    AvailabilityPage,
    ReportlistPage,
    OrdersPage,
    DeliveryTimePage,FormatTimePipe,
    MarkaspaidPage,
    SalesReportPage
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp, {},
      {
        links: [
          { component: HomePage, name: 'HomePage', segment: 'Order' },
          { component: LoginPage, name: 'LoginPage', segment: 'login' },
          { component: OrderdetailsPage, name: 'OrderdetailsPage', segment: 'orderdetails' },
          { component: ReservationPage, name: 'ReservationPage', segment: 'reservation' },
          { component: DashboardPage, name: 'DashboardPage', segment: 'dashboard' },
          { component: ReservationdetailsPage, name: 'ReservationdetailsPage', segment: 'reservationdetails'},
          { component: AddPrinterPage, name: 'AddPrinterPage', segment: 'addprinter'},
          { component: AvailabilityPage, name: 'AvailabilityPage', segment: 'availability'},
          { component: ReportlistPage, name: 'ReportlistPage', segment: 'report'},
          { component: OrdersPage, name: 'OrdersPage', segment: 'report'},
          { component: DeliveryTimePage, name: 'DeliveryTimePage', segment: 'report'},
          { component: SalesReportPage, name: 'SalesReportPage', segment: 'salesreport'}
        ]
      }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    OrderdetailsPage,
    ReservationPage,
    ReservationdetailsPage,
    AddPrinterPage,
    PrinterPage,
    DashboardPage,
    AvailabilityPage,
    ReportlistPage,
    DeliveryTimePage,
    OrdersPage,MarkaspaidPage,
    SalesReportPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    DbservicesProvider,
    NativeAudio,
    OneSignal,
    BackgroundMode,
    BluetoothSerial,
    BluetoothLE,
    ChatService,
    PrintProvider
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts